module.exports = __webpack_public_path__ + "img/logo-jetbrains.157f907a.png";